import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useApp, type Locale } from "@/context/AppProviders";

export function LocaleLayout({ locale }: { locale: Locale }) {
  const { setLocale } = useApp();

  useEffect(() => {
    setLocale(locale);
    document.documentElement.lang = locale;
  }, [locale, setLocale]);

  return <Outlet />;
}
